import { enqueueSnackbar } from "notistack";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useToast = () => {
  const { t } = useTranslation(["toasts"]);

  const pushCustomErrorToast = useCallback((value: string) => {
    enqueueSnackbar(value, { variant: "error" });
  }, []);

  const pushCustomSuccessToast = useCallback((value: string) => {
    enqueueSnackbar(value, { variant: "success" });
  }, []);

  const pushCreateErrorToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.create.error", { value: value }), { variant: "error" });
    },
    [t]
  );

  const pushCreateSuccessToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.create.success", { value: value }), { variant: "success" });
    },
    [t]
  );

  const pushUpdateErrorToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.update.error", { value: value }), { variant: "error" });
    },
    [t]
  );

  const pushUpdateSuccessToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.update.success", { value: value }), { variant: "success" });
    },
    [t]
  );

  const pushDeleteErrorToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.delete.error", { value: value }), { variant: "error" });
    },
    [t]
  );

  const pushDeleteSuccessToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.delete.success", { value: value }), { variant: "success" });
    },
    [t]
  );

  const pushFetchErrorToast = useCallback(
    (value: string) => {
      enqueueSnackbar(t("toasts:toasts.fetch.error", { value: value }), { variant: "error" });
    },
    [t]
  );

  return {
    pushCustomSuccessToast,
    pushCustomErrorToast,
    pushCreateErrorToast,
    pushCreateSuccessToast,
    pushUpdateErrorToast,
    pushUpdateSuccessToast,
    pushDeleteSuccessToast,
    pushDeleteErrorToast,
    pushFetchErrorToast,
  };
};
